import { AirdropHistoryPageTemplate } from "./template";
import { useAirdropHistoryPage } from "./logic";

export const AirdropHistoryPage = () : JSX.Element => {
    const props = useAirdropHistoryPage();

    return (
        <AirdropHistoryPageTemplate {...props}/>
    )
}